"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../../../../Types");
var React = require("react");
var Components_1 = require("../Components");
function ArvatoChangePasswordEvent(locationName, applicationData) {
    var arvatoChangePasswordEventContentRef = React.createRef();
    return new Types_1.VeriLiteWarningEvent(React.createElement(Components_1.ArvatoChangePasswordEventContent, { ref: arvatoChangePasswordEventContentRef, locationName: locationName, applicationData: applicationData }), applicationData.resources.ChangePassword, [
        new Types_1.VeriLiteEventAction(applicationData.resources.Next, "primary", function () {
            var _a;
            (_a = arvatoChangePasswordEventContentRef.current) === null || _a === void 0 ? void 0 : _a.goNext();
        }, true), new Types_1.VeriLiteEventAction(applicationData.resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
            closeModalCallback();
        })
    ]);
}
exports.ArvatoChangePasswordEvent = ArvatoChangePasswordEvent;
//# sourceMappingURL=ArvatoChangePasswordEvent.js.map